export default {
  methods: {
    /**
     * 開始位置と終了位置のoffsetが同じ場合、rangeの開始位置と終了位置を指定する処理
     * @param range
     * @param target
     * @param offset
     *
     */
    setStartEndRange(range, target, offset) {
      if (offset < 0) offset = 0;
      range.setStart(target, offset);
      range.setEnd(target, offset);
    },
    /**
     * rangeの再設定処理
     * @param selection
     * @param range
     *
     */
    resetRange(selection, range) {
      selection.removeAllRanges();
      selection.addRange(range);
    },
  },
};
